/**
 * LegacyKit Configuration
 *
 * This module initializes the LegacyKit native module with environment-specific
 * configuration from app.config.js (via expo-constants).
 */

import Constants from "expo-constants";
import { configure as configureLegacyKit } from "../../modules/legacy-kit";

export interface AppConfig {
  environment: "production" | "qa" | "dev" | "demo" | "uat";
  apiBaseUrl: string;
  amplitudeApiKey?: string;
}

/**
 * Get the app configuration from expo-constants
 * These values are set during prebuild based on APP_ENV environment variable
 */
export function getAppConfig(): AppConfig {
  const extra = Constants.expoConfig?.extra;

  if (!extra) {
    console.warn("⚠️ No extra config found, using production defaults");
    return {
      environment: "production",
      apiBaseUrl: "https://app.atfvision.net.au",
    };
  }

  return {
    environment: (extra.environment as AppConfig["environment"]) || "production",
    apiBaseUrl: (extra.apiBaseUrl as string) || "https://app.atfvision.net.au",
    amplitudeApiKey: extra.amplitudeApiKey as string | undefined,
  };
}

/**
 * Initialize LegacyKit with the current app configuration
 * Call this once during app startup
 */
export function initializeLegacyKit(): void {
  const config = getAppConfig();

  console.log("🔧 Initializing LegacyKit with config:", {
    environment: config.environment,
    apiBaseUrl: config.apiBaseUrl,
  });

  configureLegacyKit({
    apiBaseUrl: config.apiBaseUrl,
  });
}
